// Cornice grafica comune alle pagine pubbliche di reset password (stesso stile di MyLoginPage)
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Typography, Container } from '@material-ui/core';

import { urlLogo } from '../../utils/urlBase';

export const usePasswordResetStyles = makeStyles((theme) => ({
    containerbg: {
        backgroundColor: 'white',
        minHeight: '100vh',
    },
    container: {
        backgroundColor: '#e85a2c',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(3),
        boxShadow: 'none',
    },
    logo: {
        marginBottom: '1rem',
        width: '200px',
        height: 'auto',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    title: {
        color: '#e85a2c',
        fontWeight: 'bold',
        textAlign: 'center',
        letterSpacing: '2px',
        marginBottom: theme.spacing(2),
    },
    form: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    text: {
        textAlign: 'center',
        marginBottom: theme.spacing(2),
    },
    submit: {
        letterSpacing: '2px',
        marginTop: theme.spacing(2),
        backgroundColor: '#e85a2c',
        color: 'white',
        '&:hover': {
            backgroundColor: 'gray',
        }
    },
    link: {
        marginTop: theme.spacing(3),
        color: '#e85a2c',
        textAlign: 'center',
    },
}));

// Link alla login con ricaricamento della pagina: la login riparte da un'app pulita, senza lo stato
// (permessi "senza token" in cache) accumulato sulle pagine pubbliche, che in alcuni browser lasciava
// la pagina bianca dopo il login.
export const LinkLogin = ({ className, children }) => (
    <a
        href="#/login"
        className={className}
        onClick={e => {
            e.preventDefault();
            window.location.hash = '#/login';
            window.location.reload();
        }}
    >
        {children}
    </a>
);

const PasswordResetLayout = ({ title, children }) => {
    const classes = usePasswordResetStyles();

    return (
        <Container maxWidth="xl" className={classes.containerbg}>
            <Container component="main" maxWidth="xs" className={classes.container}>
                <Paper className={classes.paper}>
                    <img src={urlLogo} alt="Logo" className={classes.logo} />
                    <Typography component="h1" variant="h6" className={classes.title}>
                        {title}
                    </Typography>
                    {children}
                </Paper>
            </Container>
        </Container>
    );
};

export default PasswordResetLayout;
